<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lUJFie/tc-custom/9783989733602.jpg?1731055216422" alt="This image is the cover for the book Mrs. Harter, CLASSICS TO GO"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mrs. Harter, CLASSICS TO GO
      </h1>
      <p class="bookDescription body article font2">
        <p>In "Mrs. Harter" by E. M. Delafield, readers are drawn into the intricate world of a woman who navigates the complexities of societal expectations and personal desires. Set against the backdrop of early 20th-century England, the novel explores themes of identity, freedom, and the often conflicting roles imposed on women. Mrs. Harter, a character of remarkable depth and subtlety, finds herself at a crossroads, torn between the life she has always known and the tantalizing possibility of something more. As she grapples with her choices, the story unfolds with a keen eye for the nuances of human emotion and social dynamics. Delafield's sharp wit and poignant observations make this a timeless tale, resonating deeply with contemporary readers who continue to face the challenges of balancing tradition and self-fulfillment. "Mrs. Harter" is a compelling exploration of the courage it takes to forge one's own path in a world that often demands conformity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. M. Delafield
      </h2>
      
      <p class="authorDescription body article">E. M. Delafield (1890–1943), born Edmée Elizabeth Monica de la Pasture, was a British author best known for her sharp wit and keen observations of middle-class life. Her most famous work, *The Diary of a Provincial Lady*, established her as a master of comic fiction, but Delafield's writing spanned a wide range of genres, including novels, essays, and plays. Her works often focused on the lives and struggles of women in early 20th-century England, blending humor with subtle social critique.<br>Delafield grew up in a literary family and briefly became a postulant at a convent before pursuing a career in writing. Her experiences during World War I, serving as a volunteer nurse, deeply influenced her later work, especially in her depictions of the challenges faced by women during times of social upheaval. In *The Optimist*, one of her earlier novels, Delafield examines the tension between idealism and reality, themes that would recur throughout her writing.<br>A sharp observer of the domestic and societal roles imposed on women, Delafield brought a satirical yet empathetic voice to the struggles of everyday life. Her ability to combine humor with thoughtful social commentary secured her place as a significant figure in British literature.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?218cf57c